export enum RG2XC {
    GameResultShown = 'rg2xcGameResultShown',
    GamePaused = 'rg2xcGamePaused',
    GameResumed = 'rg2xcGameResumed',
    GameWonUpdated = 'rg2xcGameWonUpdated',
    GameStatusUpdated = 'rg2xcGameStatusUpdated',
    GameWagerUpdated = 'rg2xcGameWagerUpdated',
    PropertiesUpdated = 'rg2xcPropertiesUpdated',
    LaunchGameDone = 'rg2xcLaunchGameDone',
    PreloaderEnd = 'rg2xcPreloaderEnd',
    PreloaderProgress = 'rg2xcPreloaderProgress',
    PreloadStart = 'rg2xcPreloadStart',
    GameLoaderReady = 'rg2xcGameLoaderReady',
    UIElementClicked = 'rg2xcUIElementClicked',
    GameReadyForUnload = 'rg2xcGameReadyForUnload',
    ErrorOccurred = 'rg2xcErrorOccurred',
}

export enum XC2RG {
    LaunchGame = 'xc2rgLaunchGame',
    ShowHelp = 'xc2rgShowHelp',
    ShowPaytable = 'xc2rgShowPaytable',
    PropertiesUpdated = 'xc2rgPropertiesUpdated',
    BalanceUpdated2 = 'xc2rgBalanceUpdated2',
    PauseGame = 'xc2rgPauseGame',
    ResumeGame = 'xc2rgResumeGame',
    CloseGame = 'xc2rgCloseGame',
    SizeChanged = 'xc2rgSizeChanged',
    ErrorHandled = 'xc2rgErrorHandled',
    GetProperties = 'xc2rgGetProperties',
    GetPropertiesResponse = 'xc2rgGetPropertiesResponse',
}

export type XC2RGBalanceUpdated = {balance: number;};

export type XC2RG_PROPERTIES_UPDATED = {
    keysAndValues: {
        soundEnabled: boolean;
    };
};

export type XC2RG_SIZE_CHANGED = {
    width: number;
    height: number;
};

export type XC2RG_ERROR_HANDLED = {
    error: string;
};

export type XC2RGPauseGame = {
    condition: 'waitUntilHandEnd' | 'waitUntilAnimationEnd';
};

export type XC2RG_GET_PROPERTIES_KEYS = 'userId' | 'rgToken' | 'siteId' | 'hostId' | 'platform' | 'isNewSession' |
    'currency' | 'languageCode' | 'countryCode' | 'playForFun' | 'soundEnabled' | 'vendorGameConfig' | 'showPlayMoneyWithDecimal';

export type XC2RG_GET_PROPERTIES = {
    requestId: string;
    keys: [XC2RG_GET_PROPERTIES_KEYS];
};

export type XC2RG_GET_PROPERTIES_RESPONSE = {
    requestId: string;
    keysAndValues: {
        rgToken: string;
        siteId: number;
        hostId: number;
        platform: number;
        isNewSession: boolean;
        currency: string;
        languageCode: string;
        countryCode: string;
        playForFun: boolean;
        soundEnabled: boolean;
        vendorGameConfig: string;
        showPlayMoneyWithDecimal: string;
    };
};

export type XCLaunchOptions = {
    userId: string;
    rgToken: string;
    siteId: number;
    hostId: number;
    platform: number;
    isNewSession: boolean;
    currency: string;
    languageCode: string;
    countryCode: string;
    playForFun: boolean;
    soundEnabled: boolean;
    vendorGameConfig: string;
    showPlayMoneyWithDecimal: boolean;
    gameServer: string;
    siteName: string;
};

export type XCClientMessage<D = Record<string, any>> = {
    msgId: string;
    keysAndValues: D;
};

export type XC2RGLaunchGame = XCClientMessage<XCLaunchOptions>;

export type XC2RGEventsMap = {
    [XC2RG.LaunchGame]: XC2RGLaunchGame;
    [XC2RG.ShowPaytable]: void;
    [XC2RG.ShowHelp]: void;
    [XC2RG.PropertiesUpdated]: XC2RG_PROPERTIES_UPDATED;
    [XC2RG.BalanceUpdated2]: XC2RGBalanceUpdated;
    [XC2RG.PauseGame]: XC2RGPauseGame;
    [XC2RG.ResumeGame]: void;
    [XC2RG.CloseGame]: void;
    [XC2RG.SizeChanged]: XC2RG_SIZE_CHANGED;
    [XC2RG.ErrorHandled]: XC2RG_ERROR_HANDLED;
    [XC2RG.GetProperties]: XC2RG_GET_PROPERTIES;
    [XC2RG.GetPropertiesResponse]: XC2RG_GET_PROPERTIES_RESPONSE;
};

export type RG2XCGameStatusUpdated = {
    status: 'autoPlayStart' | 'autoPlayEnd' | 'handEnd' | 'handStart';
};

export type RG2XCError = {error: string; details?: string;};

export type RG2XCEventsMap = {
    [RG2XC.GameResultShown]: void;
    [RG2XC.GamePaused]: void;
    [RG2XC.GameResumed]: void;
    [RG2XC.GameWonUpdated]: {value: number;};
    [RG2XC.GameStatusUpdated]: RG2XCGameStatusUpdated;
    [RG2XC.GameWagerUpdated]: {value: number;};
    [RG2XC.PropertiesUpdated]: {soundEnabled: boolean;};
    [RG2XC.LaunchGameDone]: void;
    [RG2XC.PreloaderEnd]: void;
    [RG2XC.PreloaderProgress]: {
        percentage: number;
        localizedText: string;
    };
    [RG2XC.PreloadStart]: void;
    [RG2XC.GameLoaderReady]: void;
    [RG2XC.UIElementClicked]: {elementId: string;};
    [RG2XC.GameReadyForUnload]: {localizedMessage: string;};
    [RG2XC.ErrorOccurred]: RG2XCError;
};

export type PSLaunchResponse = {
    status: string;
    playerSession: string;
    operator: string;
    gamename: string;
    playForFun: boolean;
};

export type PSLaunchError = {
    code: string;
    description: string;
    errorDisplayOptions: any;
};
